module.exports = __webpack_public_path__ + "static/1-012-9b020c44d2ce2d2cc26ab31e43c7e08e.png";